import { VideoGif } from 'components/basic/VideoGif'
import { Button } from 'components/Phantom/Button'
import { Type } from 'components/Type'
import { FC } from 'react'
import styles from './PeerReviewedFindings.module.scss'
import { PeerReviewedFindingsProps } from './PeerReviewedFindings.types'

export const PeerReviewedFindings: FC<PeerReviewedFindingsProps> = (props) => {
	const {} = props
	return (
		<section className={styles.container}>
			<div className={styles.content}>
				<header>
					<Type.Headline1 as={'h2'}>Peer-reviewed findings that prove better sleep</Type.Headline1>
					<Type.Body1>In a free-living study, we examined how sleep and cardiovascular health metrics were positively affected by sleeping for one week on the Pod.</Type.Body1>
					<Button.TextLink
						id={'peer-reviewed-read-more'}
						href={'https://www.mdpi.com/2306-5354/11/4/352'}
					>
						Read more here
					</Button.TextLink>
				</header>
				<div className={styles.shade} />
				<VideoGif
					src={'https://res.cloudinary.com/eightsleep/video/upload/f_auto,q_auto/t_video-gif/sleep_personal_hi_res_f3zlrl.mp4'}
					className={styles.media}
				/>
			</div>
		</section>
	)
}
